import {
  GamoraFoundationTask,
  GamoraFoundationTaskInput,
  assert,
  debugCreate,
} from '@ver.id/libs.internal.gamora';
const debug = debugCreate({
  namespace: 'horuz:protocols:chulak:tasks:async:authentication-timer',
});

/**
 * Input
 */
export interface HoruzProtocolChulakTaskAuthenticationTimerInput extends GamoraFoundationTaskInput {
  callback: () => Promise<void>;
  ms: number;
}

/**
 * Polling task
 */
export class HoruzProtocolChulakTaskAuthenticationTimer extends GamoraFoundationTask<HoruzProtocolChulakTaskAuthenticationTimerInput> {
  private _timer: NodeJS.Timeout | null = null;
  private _ms: number;
  private _callback: () => Promise<void>;
  constructor(input: HoruzProtocolChulakTaskAuthenticationTimerInput) {
    super(input);

    this._ms = input.ms;
    this._callback = input.callback;
  }

  /**
   * Start polling
   */
  override async $start(): Promise<void> {
    assert(
      this._timer === null,
      'Invalid call: $start must only be called once.',
    );

    this._timer = setTimeout(() => {
      this._timer = null;
      this._callback().catch((e) => {
        debug.trace(e?.message, e?.stack);
      });
    }, this._ms);
  }

  /**
   * Terminate
   */
  override async $terminate(): Promise<void> {
    if (this._timer !== null) {
      clearTimeout(this._timer);
      this._timer = null;
    }
  }
}
